import React from 'react';

const Arrow: React.FC = () => (
  <svg
    className="arrow-right"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.00041 0.333984L5.82541 1.50898L10.4754 6.16732H0.33374V7.83398H10.4754L5.82541 12.4923L7.00041 13.6673L13.6671 7.00065L7.00041 0.333984Z" />
  </svg>
);

export default Arrow;
